var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookPublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2503 9.5C18.2503 7.17936 17.3284 4.95376 15.6875 3.31282C14.0465 1.67188 11.8209 0.750004 9.50028 0.750004C7.29696 0.747969 5.17398 1.57724 3.5554 3.07218C1.93683 4.56711 0.941814 6.61765 0.769121 8.81419C0.596429 11.0107 1.25877 13.1916 2.62384 14.9211C3.98891 16.6506 5.95622 17.8014 8.13278 18.1438V12.0288H5.91278V9.5H8.13403V7.5725C8.13403 5.38 9.44028 4.1675 11.439 4.1675C12.3965 4.1675 13.3978 4.33875 13.3978 4.33875V6.4925H12.294C11.2065 6.4925 10.869 7.1675 10.869 7.85875V9.5H13.2953L12.9078 12.0288H10.8678V18.1438C12.9259 17.8178 14.8002 16.7682 16.1535 15.1837C17.5068 13.5992 18.2503 11.5838 18.2503 9.5Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9078 12.0288L13.2953 9.50001H10.8691V7.85876C10.8691 7.16751 11.2066 6.49251 12.2941 6.49251H13.3978V4.33751C13.3978 4.33751 12.3966 4.16626 11.4391 4.16626C9.43906 4.16626 8.13406 5.37876 8.13406 7.57126V9.50001H5.91406V12.0288H8.13531V18.1438C9.0414 18.2864 9.96422 18.2864 10.8703 18.1438V12.0288H12.9078Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookPublic);
export default __webpack_public_path__ + "static/media/facebookPublic.804c7512a4f59b968eed7ad13bc7c467.svg";
export { ForwardRef as ReactComponent };